// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"98157613","712":"4d575ebf"}[chunkId] + ".chunk.css";
};